export default __webpack_public_path__ + "static/media/ltd-icon.97b6d5ff.svg";